import { TeamDataObject } from "../DataStorage/TeamDataObject";
import { DataUtilities } from "../../Common/DataUtilities";

export class UserData extends TeamDataObject {
    userDataId: string;
    name?: string;
    listName: string;
    dataDefinitionName: string;
    dataDefinitionId: string;
    data: object;

    constructor(
        userDataId: string | undefined,
        dataDefinitionName: string,
        dataDefinitionId: string,
        data: object,
        listName?: string
    ) {
        super();
        this.userDataId = userDataId ?? DataUtilities.generateUniqueId();
        this.dataDefinitionName = dataDefinitionName;
        this.dataDefinitionId = dataDefinitionId;
        this.listName = listName ?? dataDefinitionName;
        this.data = data;
    }
}
